import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'cv-tab',
	templateUrl: './tab.component.html',
	styleUrls: ['./tab.component.scss']
})
export class TabComponent {
	/**
   * @public tab title.
   */
	@Input() title: string;
	/**
   * @public set active tab.
   */
	@Input() active = false;
	/**
   *  @public set icon element.
   */
	@Input() icon: string;
	@Input() tooltip: string;
	@Output() tabActivated: EventEmitter<any> = new EventEmitter<any>();
}
